export function setGradient({ fromColor, toColor }) {
  if (typeof document === `undefined`) {
    return
  }

  document.querySelector('html').style.backgroundImage = `linear-gradient(to right bottom, ${fromColor}, ${toColor})`;
}